import { css } from 'emotion';

export const styles = {
  wrapper: css({
    position: 'absolute',
    zIndex: 9999,
  }),
};
